const { jQuery } = window;

/**
 * 投稿本文展開コンポーネント
 */
export default class PostBodyExpander {
  /**
   * Public: コンストラクタ
   *
   * options - 以下のようなプロパティを持つオブジェクト。
   *           linkSelector     - 展開用リンクのセレクタ。
   *           fulltextSelector - 展開後の全文を含む要素のセレクタ。
   *
   * fulltextSelector で指定された要素は、linkSelector で指定された要素の
   * 次にある要素の中で最も近いものが使われます。
   */
  constructor(options) {
    this.options = options;
  }

  init() {
    this.bindEvents();
  }

  /**
   * Internal: イベントハンドラを設定します。
   */
  bindEvents() {
    jQuery(this.options.linkSelector).on(
      "click",
      this.handleLinkClick.bind(this),
    );
  }

  handleLinkClick(event) {
    event.stopPropagation();
    const target = jQuery(event.currentTarget);
    target.parent().html(target.next(this.options.fulltextSelector).html());
  }
}
